// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file handlebar.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file handlebar.proto.
 */
export const file_handlebar: GenFile = /*@__PURE__*/
  fileDesc("Cg9oYW5kbGViYXIucHJvdG8SC2dycGMuYXBpLnYxIksKCUhhbmRsZWJhchIKCgJpZBgBIAEoAxIMCgRuYW1lGAIgASgJEhIKCmV4cHJlc3Npb24YAyABKAkSEAoIaG90X25hbWUYBCABKAlCBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.Handlebar
 */
export type Handlebar = Message<"grpc.api.v1.Handlebar"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string expression = 3;
   */
  expression: string;

  /**
   * @generated from field: string hot_name = 4;
   */
  hotName: string;
};

/**
 * Describes the message grpc.api.v1.Handlebar.
 * Use `create(HandlebarSchema)` to create a new message.
 */
export const HandlebarSchema: GenMessage<Handlebar> = /*@__PURE__*/
  messageDesc(file_handlebar, 0);

